<template>
  <div>
    <div class="dashboard-main-content" v-if="price != null">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <form id="priceForm">
            <div class="form-box">
              <div class="form-content pb-2">
                <div class="row justify-content-between">
                  <div class="col-lg-12">
                    <div class="card-item p-3">
                      <div class="contact-form-action">
                        <h3 class="title mb-3">Fiyatlandırma</h3>
                        <div class="row">
                          <div class="col-sm-6">
                          <div class="input-box">
                            <base-edit-input
                                v-model="price.name"
                                :rules="'required'"
                                :type="'text'"
                                :label="'Adı'">
                            </base-edit-input>
                          </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="input-box">
                              <base-select-input
                                  v-model="price.cruiseId"
                                  :optionList="cruiseList"
                                  :rules="'required'"
                                  :label="'Cruise'"
                                  :href="basePath+'/cruises/'+price.cruiseId"
                                  :href-text="price.cruiseId">
                              </base-select-input>
                            </div>
                          </div>
                          <div class="col-sm-6" v-show="price.id != null">
                            <div class="input-box">
                              <base-select-input
                                  v-model="pricingMarketId"
                                  :optionList="marketList"
                                  :label="'Market'">
                              </base-select-input>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="input-box">
                              <base-select-input
                                  v-model="price.pricingMethod"
                                  :optionList="pricingMethodOptions"
                                  :rules="'required'"
                                  :label="'Fiyatlandırma Yöntemi'">
                              </base-select-input>
                            </div>
                          </div>
                          <div class="col-sm-6">
                            <div class="input-box">
                              <base-select-input
                                  v-model="price.earlyBooking"
                                  :optionList="[{name:'Özelleştirilmiş Erken Rezervasyon İndirimi Var',id:'enabled'},{name:'Standart Erken Rezervasyon İndirimi',id:'disabled'}]"
                                  :rules="'required'"
                                  :label="'Özelleştirilmiş Erken Rezervasyon İndirimi Durumu'">
                              </base-select-input>
                            </div>
                          </div>
                          <div class="col-sm-6 m-auto pl-4" v-if="projectName === 'selectum'">
                            <div class="row" >
                              <div class="input-box mb-2">
                                <base-select-input
                                    v-model="selectedPricingPeriodId"
                                    :optionList="pricingPeriodList"
                                    :rules="'required'"
                                    :label="'Fiyatlandırma Periyodu'">
                                </base-select-input>
                              </div>
                              <div class="btn-box mt-auto p-auto ml-lg-2 mb-lg-2">
                                <button :disabled="selectedPricingPeriodId === 0"
                                        :class="selectedPricingPeriodId === 0 ? 'disabled' : ''"
                                        @click="openEditPricingPeriodModal" class="theme-btn" type="button">Güncelle</button>
                                <button @click="openCreatePricingPeriodModal" class="theme-btn" type="button">Yeni</button>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12">
                            <div class="btn-box mt-2">
                              <button v-if="price.id == null" :class="{'disabled' : !formValid}" @click="create" class="theme-btn" type="button">Kaydet</button>
                              <button v-if="price.id != null" :class="{'disabled' : !formValid}" @click="update" class="theme-btn" type="button">Güncelle</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-content pb-2" v-if="roomList != null && price.id != null">

                <h3 class="title">Ücret Listesi</h3>

                <div class="table-form table-responsive">
                  <table class="table">
                    <thead>
                    <tr>
                      <th scope="col">Oda Adı</th>
                      <th>Yetişkin Ücreti</th>
                      <th>ROS İndirim Miktarı</th>
                      <th>Standart İndirim Miktarı</th>
                      <th>Vergi Ücreti</th>
                      <th>İkinci Misafir Çarpanı</th>
                      <th v-if="price.pricingMethod === 'dynamic'">Üçüncü Misafir Çarpanı</th>
                      <th v-if="price.pricingMethod === 'dynamic'">Dördüncü Misafir Çarpanı</th>
                      <th>Extra Misafir Çarpanı</th>
                      <th>Yalnız Misafir Çarpanı</th>
                      <th v-if="price.earlyBooking === 'enabled'">Erken Rezervasyon İndirimi</th>
                      <th v-if="price.earlyBooking === 'enabled'">Erken Rezervasyon İndirimi ( % )</th>
                      <th>Hesaplanmış Yetişkin Fiyatı</th>
                      <th>Hesaplanmış Yalnız-Yetişkin Fiyatı</th>
                      <th>Hesaplanmış Extra-Misafir Fiyatı</th>
                      <th>Hesaplanmış Çocuk Fiyatı</th>
<!--                      <th>Action</th>-->
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="room in roomList" :key="room.id" v-if="myRoomPrice !== null && pricingMarketId != null">
                      <th scope="row">
                        <input type="text" disabled v-bind:value="myRoomPrice[room.id].roomName">
                      </th>
                      <th>
                        <input class="price-input" type="number" step=".10" v-bind:value="myRoomPrice[room.id].adultPrice" @input="myRoomPrice[room.id].adultPrice = $event.target.value">
                      </th>
                      <th>
                        <input class="price-input" type="number" step=".10" v-bind:value="myRoomPrice[room.id].rosDiscount" @input="myRoomPrice[room.id].rosDiscount = $event.target.value">
                      </th>
                      <th>
                        <input class="price-input" type="number" step=".10" v-bind:value="myRoomPrice[room.id].standardDiscount" @input="myRoomPrice[room.id].standardDiscount = $event.target.value">
                      </th>
                      <th>
                        <input class="price-input" type="number" step=".05" v-bind:value="myRoomPrice[room.id].taxPrice" @input="myRoomPrice[room.id].taxPrice = $event.target.value">
                      </th>
                      <th>
                        <input class="price-input" type="number" step=".05" v-bind:value="myRoomPrice[room.id].secondGuestMultiplier" @input="myRoomPrice[room.id].secondGuestMultiplier = $event.target.value">
                      </th>
                      <th v-if="price.pricingMethod === 'dynamic'">
                        <input class="price-input" type="number" step=".05" v-bind:value="myRoomPrice[room.id].thirdGuestMultiplier" @input="myRoomPrice[room.id].thirdGuestMultiplier = $event.target.value">
                      </th>
                      <th v-if="price.pricingMethod === 'dynamic'">
                        <input class="price-input" type="number" step=".05" v-bind:value="myRoomPrice[room.id].fourthGuestMultiplier" @input="myRoomPrice[room.id].fourthGuestMultiplier = $event.target.value">
                      </th>
                      <th>
                        <input class="price-input" type="number" step=".05" v-bind:value="myRoomPrice[room.id].extraGuestMultiplier" @input="myRoomPrice[room.id].extraGuestMultiplier = $event.target.value">
                      </th>
                      <th>
                        <input class="price-input" type="number" step=".05" v-bind:value="myRoomPrice[room.id].soloGuestMultiplier" @input="myRoomPrice[room.id].soloGuestMultiplier = $event.target.value">
                      </th>
                      <th v-if="price.earlyBooking === 'enabled'">
                        <input class="price-input" type="number" step="1" v-bind:value="myRoomPrice[room.id].earlyBookingDiscount" @input="myRoomPrice[room.id].earlyBookingDiscount = $event.target.value">
                      </th>
                      <th v-if="price.earlyBooking === 'enabled'">
                        <input class="price-input" type="number" step="1" v-bind:value="myRoomPrice[room.id].earlyBookingPercentageDiscount" @input="myRoomPrice[room.id].earlyBookingPercentageDiscount = $event.target.value">
                      </th>
                      <th>
                        {{myRoomPrice[room.id].calculatedAdultPrice}} €
                      </th>
                      <th>
                        {{myRoomPrice[room.id].calculatedSoloGuestPrice}} €
                      </th>
                      <th>
                        {{myRoomPrice[room.id].calculatedExtraGuestPrice}} €
                      </th>
                      <th>
                        {{myRoomPrice[room.id].calculatedChildGuestPrice}} €
                      </th>
<!--                      <th>-->
<!--                        <button class="btn cancel-btn" type="button" v-if="myRoomPrice[room.id].id == null" @click="createRoomPrice(myRoomPrice[room.id])">Save</button>-->
<!--                        <button class="btn cancel-btn" type="button" v-if="myRoomPrice[room.id].id != null" @click="updateRoomPrice(myRoomPrice[room.id])">Update</button>-->
<!--                      </th>-->
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div>
    </div>
  </div>
</template>

<script>
import BaseSelectInput from "../base/BaseSelectInput";
import BaseEditInput from "../base/BaseEditInput";
import validationFormUtils from "../../util/validationFormUtils";
import objectUtils from "../../util/objectUtils";
import messagePopupManager from "../../util/messagePopupManager";
import {dd_MM_yyyy, dd_MM_yyyy_tire, ddMMyyyyHHmm, yyyy_MM_dd_tire} from "../../util/filters";

export default {
  name: "PriceDetail",
  components: {BaseEditInput, BaseSelectInput},
  data:function (){
    return{
      formValid:false,
      pricingMethodOptions:[
        {id : "static", name : "static"},
        {id : "dynamic", name : "dynamic"}
      ]
      // ,
      // selectedPricingPeriod: 0
    }
  },
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath;
      }
    },
    price:{
      get(){
        return this.$store.getters.getPrice;
      },
    },
    roomList:{
      get(){
        return this.$store.getters.getRoomList;
      },
    },
    roomPriceList:{
      get(){
        return this.$store.getters.getRoomPriceList;
      },
    },
    cruiseList:{
      get(){
        return this.$store.getters.getCruiseList;
      },
    },
    myRoomPrice:{
      get(){
        return this.$store.getters.getPriceDetailRoomPrice;
      },
      set(value){
        this.$store.commit("setPriceDetailRoomPrice",value);
      }
    },
    marketList:{
      get(){
        return this.$store.getters.getMarketList;
      },
      set(value){
        this.$store.commit("setMarketList",value)
      }
    },
    pricingMarketId:{
      get(){
        return this.$store.getters.getPricingMarketId;
      },
      set(value){
        this.$store.commit("setPricingMarketId",value)
      }
    },
    selectedPricingPeriodId:{
      get(){
        return this.$store.getters.getSelectedPricingPeriodId;
      },
      set(val){
        this.$store.commit("setSelectedPricingPeriodId", val);
      }
    },
    projectName:{
      get(){
        return this.$store.getters.getProjectName;
      }
    },
    pricingPeriodList:{
      get(){
        let pricingPeriodList =  this.$store.getters.getPricingPeriodList;

        pricingPeriodList.sort(function(a,b){
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.endDate) - new Date(a.endDate);
        });

        if(pricingPeriodList.filter(pricingPeriod=> pricingPeriod.id === 0).length === 0) {
          pricingPeriodList.push({
            id: 0,
            startDate: "2000-01-01",
            endDate: "2030-01-01"
          })
        }

        pricingPeriodList.forEach(pricingPeriod => {
          pricingPeriod.startDate = yyyy_MM_dd_tire(pricingPeriod.startDate);
          pricingPeriod.endDate = yyyy_MM_dd_tire(pricingPeriod.endDate);

          if(pricingPeriod.id === 0){
            pricingPeriod.name = "Standart Periyod";
          }else{
            pricingPeriod.name = dd_MM_yyyy(pricingPeriod.startDate) + " - " + dd_MM_yyyy(pricingPeriod.endDate);
          }
        })

        return pricingPeriodList;
      },
    }
  },
  methods:{
    create(){
      if(this.formValid){
        this.$store.dispatch("createPrice", this.price).then(response => {
          messagePopupManager.showSuccess();
        })
      }
    },
    update(){
      if(this.formValid){
        this.$store.dispatch("updatePrice", this.price).then(response => {
          messagePopupManager.showSuccess()
        })

        for(let i=0;i<Object.keys(this.myRoomPrice).length;i++){
          let selectedRoom = this.myRoomPrice[Object.keys(this.myRoomPrice)[i]];
          this.updateRoomPrice(selectedRoom);
        }

      }
    },
    updateRoomPrice(roomPrice){
      let copiedRoomPrice = {}
      roomPrice.pricingPeriodId = this.selectedPricingPeriodId;
      objectUtils.deepCopy(copiedRoomPrice,roomPrice)
      delete copiedRoomPrice.roomName
      this.$store.dispatch("createOrUpdateRoomPrice",copiedRoomPrice).then(response => {
        $(".modal").modal('hide')
        messagePopupManager.showSuccess()
      })
    },
    openCreatePricingPeriodModal(){
      this.$store.commit("setEditPricingPeriod", {});
      $("#createPricingPeriodModal").modal("show");

    },
    openEditPricingPeriodModal(){
      let selectedPricingPeriod = this.pricingPeriodList.filter(pricingPeriod => pricingPeriod.id === this.selectedPricingPeriodId)[0];
      this.$store.commit("setEditPricingPeriod", JSON.parse(JSON.stringify(selectedPricingPeriod)));
      $("#createPricingPeriodModal").modal("show");

    },
    createRoomPrice(roomPrice){
      let copiedRoomPrice = {}
      objectUtils.deepCopy(copiedRoomPrice,roomPrice)
      delete copiedRoomPrice.roomName
      this.$store.dispatch("createRoomPrice",copiedRoomPrice).then(response => {
        $(".modal").modal('hide')
        messagePopupManager.showSuccess()
      })
    },
  },
  updated() {
    setTimeout(function (){
      $(".select-contain-select").selectpicker('refresh');
    },100)
    $(".select-contain-select").selectpicker({
      size: 5,
      noneSelectedText: 'Select One'
    });
  },
  watch:{
    price:{
      deep:true,
      handler:function (){
        this.$store.dispatch("loadRoomList", this.price.cruiseId)
        validationFormUtils.checkFormFields(this);
      }
    },
    myRoomPrice:{
      deep:true,
      handler:function (myRoomPrice,val){
        if(myRoomPrice == null){
          return null;
        }
        for(let i=0;i<Object.keys(myRoomPrice).length;i++){
          let selectedRoom = myRoomPrice[Object.keys(myRoomPrice)[i]];
          selectedRoom.calculatedAdultPrice =  ((selectedRoom.adultPrice*1) + selectedRoom.taxPrice*1).toFixed(2)
          selectedRoom.calculatedSoloGuestPrice =  ((selectedRoom.adultPrice*1 * selectedRoom.soloGuestMultiplier*1) + selectedRoom.taxPrice*1).toFixed(2)
          selectedRoom.calculatedExtraGuestPrice =  ((selectedRoom.adultPrice*1 * selectedRoom.extraGuestMultiplier*1) + selectedRoom.taxPrice*1).toFixed(2)
          selectedRoom.calculatedChildGuestPrice =  (selectedRoom.taxPrice*1).toFixed(2)
        }
      }
    },
    pricingMarketId:{
      deep:true,
      handler:function (){
        this.$store.commit("setSelectedPricingPeriodId", this.selectedPricingPeriodId);
        this.$store.dispatch("initPriceDetailRoomPrice");
      }
    },
    selectedPricingPeriodId:{
      deep:true,
      handler:function (){
        this.$store.commit("setSelectedPricingPeriodId", this.selectedPricingPeriodId);
        this.$store.dispatch("initPriceDetailRoomPrice");
      }
    }
  },
  beforeMount() {
    this.$store.commit("setSelectedPricingPeriodId", 0);
  }
}
</script>

<style scoped>

.price-input{
  padding: 5px!important;
  background-color: #f5f5ff!important;
  width: 65px;
}

</style>